function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("path", {
  opacity: 0.01,
  fill: "#fff",
  d: "M0 0h16v16H0z"
});

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M13.803 3.753c.26.26.26.684 0 .944l-1.22 1.22-2.5-2.5 1.22-1.22c.26-.26.684-.26.944 0l1.556 1.556zM2 14v-2.5l7.377-7.377 2.5 2.5L4.5 14H2z",
  fill: "#fff"
});

var SvgEdit = function SvgEdit(props) {
  return React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none"
  }, props), _ref, _ref2);
};

export default "data:image/svg+xml,%3Csvg width='16' height='16' viewBox='0 0 16 16' fill='none' xmlns='http://www.w3.org/2000/svg'%3E %3Crect opacity='0.01' width='16' height='16' fill='white'/%3E %3Cpath fill-rule='evenodd' clip-rule='evenodd' d='M13.8033 3.75338C14.0633 4.01338 14.0633 4.43671 13.8033 4.69671L12.5833 5.91671L10.0833 3.41671L11.3033 2.19671C11.5633 1.93671 11.9867 1.93671 12.2467 2.19671L13.8033 3.75338ZM2 14V11.5L9.37667 4.12338L11.8767 6.62338L4.5 14H2Z' fill='white'/%3E %3C/svg%3E";
export { SvgEdit as ReactComponent };